import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getSpecialReportsSelector } from '../selectors'
import { setNarrative, saveSpecialReport } from '../store/specialReports.actions'
import TextArea from '../../../components/textArea/TextArea.component'
import { IonRow, IonCol, IonLabel, IonContent } from '@ionic/react'
import InfoBox from '../../../components/infoBox/InfoBox.component'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'

const Narrative: React.FC = () => {
  const specialReportsState = useSelector(getSpecialReportsSelector)
  const { narrative } = specialReportsState
  const serviceConfig = useSelector(getServiceConfigSelector)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const onChange = (e: CustomEvent) => {
    dispatch(setNarrative(e.detail.value))
    dispatch(saveSpecialReport())
  }

  const phiMessage = serviceConfig?.SPECREP_PSWPM || ''

  return (
    <IonContent color='light'>
      <IonRow>
        {phiMessage && (
          <IonCol size='12' className='ion-padding'>
            <InfoBox text={phiMessage} />
          </IonCol>
        )}
        <IonRow className='ion-margin-top w-100'>
          <IonCol size='12'>
            <IonLabel>{t('specialReports.narrative')}</IonLabel>
            <TextArea
              isPHI={false}
              dataTestID={t('specialReports.narrative')}
              className='specialreports-narrative-text-area'
              rows={8}
              disabled={false}
              maxlength={10000}
              value={narrative}
              onChangeAction={(e) => onChange(e)}
            />
          </IonCol>
        </IonRow>
      </IonRow>
    </IonContent>
  )
}

export default Narrative
